<template>
  <div>
    <template>
      <b-row>
        <b-col>
          <router-link :to="{ name: 'EXABSurveysList' }" class="mb-1 btn btn-sm btn-default float-right">{{ $t('buttons.backToList') }}</router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <Loader v-if="isLoading"></Loader>
            <Form v-else
              :handle-submit="onSendForm"
              :values="retrieved"
              :violations="violations"
              :retrieve="retrieve"
              @submit="onSendForm($event)"/>
          </b-card>
        </b-col>
      </b-row>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Form from './Form'
import Loader from '@/components/Dashboard/Layout/Loader'
import { checkPagePermission } from '@/utils/checkRoles'

export default {
  name: 'Update',
  components: {
    Form,
    Loader
  },
  beforeDestroy () {
    this.reset()
  },
  created () {
    this.retrieve(this.id)
  },
  beforeCreate () {
    checkPagePermission('exabagreements', 'EXABSurveysUpdate')
  },
  watch: {
    updated (val) {
      if (val) this.$router.push({ name: 'EXABSurveysList' })
    }
  },
  computed: {
    id () {
      return this.$route.params.id
    },
    ...mapGetters({
      updated: 'surveys/update/updated',
      retrieved: 'surveys/show/retrieved',
      isLoading: 'surveys/show/isLoading',
      violations: 'surveys/update/violations'
    })
  },
  methods: {
    onSendForm (item) {
      this.update(item)
    },
    ...mapActions({
      update: 'surveys/update/update',
      retrieve: 'surveys/show/retrieve',
      reset: 'surveys/update/reset'
    })
  }
}
</script>

<style scoped>

</style>
